import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'hooks/store';
import { refreshDataAction, userDataRefreshedSelector } from 'state/slices/session';
import { storageClient } from 'infra/storage';
import { STORAGE_SESSION_KEY } from 'constants/misc';
import { useHistory } from 'react-router';
import { ROUTES } from 'constants/routes';

import {
  Alert,
  Logo,
  Spinner,
} from 'UI';

import LoginForm from './components/LoginForm';
import {
  BaseContainer,
  ContentContainer,
  LogoContainer,
} from './style';

const ApplicationLoader = (): JSX.Element => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isDataRefreshed = useSelector(userDataRefreshedSelector);
  const [hasStoredSession] = useState(storageClient.getItem(STORAGE_SESSION_KEY));

  const isCheckingSession: boolean = hasStoredSession === 'true' && isDataRefreshed === false;

  useEffect(() => {
    if (isCheckingSession) {
      dispatch(refreshDataAction());
    } else {
      history.replace(ROUTES.root);
    }
  }, [isCheckingSession]);

  return (
    <BaseContainer>
      <LogoContainer>
        <Logo />
      </LogoContainer>
      <ContentContainer>
        {
          hasStoredSession === 'true' && !isCheckingSession && (
            <Alert message="Sessao expirada." type="error" closable showIcon banner />
          )
        }
        {
          isCheckingSession
            ? (
              <Spinner size="large" />
            )
            : (
              <LoginForm />
            )
        }
      </ContentContainer>
    </BaseContainer>
  );
};

export default ApplicationLoader;
